import React, { useState } from "react";
import { Navbar, Nav, NavbarBrand } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";

import { Auth } from "aws-amplify";

import { useAuthContext } from "../../contexts/authContext";

export default function TopBar() {
  const [toggled, setToggled] = useState(false);
  const { userHasAuthenticated } = useAuthContext();
  const history = useHistory();

  async function handleLogout() {
    await Auth.signOut();

    userHasAuthenticated(false);
    history.push("/login");
  }

  function toggleSideNav() {
    setToggled((pv) => !pv);
    toggled
      ? document.body.classList.remove("sb-sidenav-toggled")
      : document.body.classList.add("sb-sidenav-toggled");
  }

  return (
    <Navbar bg="dark" expand="lg">
      <Nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
        <LinkContainer to="/engines">
          <NavbarBrand>Foreks SAE</NavbarBrand>
        </LinkContainer>
        <button
          className="btn btn-link btn-sm order-1 order-lg-0"
          id="sidebarToggle"
          onClick={() => toggleSideNav()}
        >
          <FontAwesomeIcon icon="bars" />
        </button>
        <form className="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-3 my-2 my-md-0"></form>
        <Nav.Link className="text-light" onClick={() => handleLogout()}>
          <FontAwesomeIcon icon="door-open" />
        </Nav.Link>
      </Nav>
    </Navbar>
  );
}
